var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.7476185,15.107839 L24.7476185,19.7003525 L28.2265044,20.3269476 L28.2265044,15.7338532 L24.7476185,15.107839 Z M25.969447,16.5697005 L27.004095,16.7558639 L27.004095,18.8649408 L25.969447,18.6787774 L25.969447,16.5697005 L25.969447,16.5697005 Z M5.52349559,21.2724309 L8.79719447,13.784656 L12.8493843,12.394675 L12.8493843,8.41684909 L15.148118,8.41684909 L15.148118,11.6015204 L25.8805762,7.90032564 C22.5075511,15.703068 14.5643587,21.0965777 5.52349559,21.2724309 Z M24.7563313,23.289007 L27.004095,23.6953136 L27.004095,28.3781498 C26.3005344,27.6615225 25.5474559,26.9939773 24.7563313,26.3727551 L24.7563313,23.289007 Z M26.9937849,6.22340329 L16.3699466,9.88742345 L16.3699466,7.19473457 L11.6271201,7.19473457 L11.6271201,11.5217983 L7.89222235,12.802579 L4.24590497,21.1430459 C4.27959456,21.2786751 4.64625929,23.3518843 4.64625929,23.3518843 C6.46709456,22.8658557 8.378398,22.6030197 10.350546,22.6030197 C18.4575395,22.6030197 25.5560235,26.9871523 29.4113034,33.5065001 L30.4552451,32.857397 C29.7993146,31.7505818 29.0494308,30.7073699 28.2265044,29.7277615 L28.2265044,22.674029 L23.5345028,21.8261289 L23.5345028,25.4764991 C20.2474442,23.2220637 16.3602172,21.778499 12.1549721,21.4568517 C18.6593866,19.4899385 24.0331668,14.8856627 26.8006506,8.85031057 L32.278549,21.461789 L33.7468053,21.7352255 L26.9937849,6.22340329 Z M20,4.97379915e-14 C8.97188662,4.97379915e-14 2.84217094e-14,8.97214447 2.84217094e-14,19.9999274 C2.84217094e-14,31.028146 8.97188662,40 20,40 C31.0281134,40 40,31.028146 40,19.9999274 C40,8.97214447 31.0281134,4.97379915e-14 20,4.97379915e-14 Z M20.03,1.72 C30.1268201,1.72 38.34,9.93372772 38.34,20.0299335 C38.34,30.1262838 30.1268201,38.3403003 20.03,38.3403003 C9.93375754,38.3403003 1.72,30.1262838 1.72,20.0299335 C1.72,9.93372772 9.93375754,1.72 20.03,1.72 L20.03,1.72 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ideation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "...-Navigation/Head-nav/Prod-Copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-+-Prod-name"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6d6c91b9ad6b7b54e612fdcb77cf3f86.svg";
export { ForwardRef as ReactComponent };